import { Component, OnInit, Renderer2 } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { PopupService } from '../../../services/popup.service';
import { PopupEnum } from '../../../constants/popup.enum';
import { IGlobalEmployeeInfoModel } from '../../../entities-api/IGlobalEmployeeInfoModel';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'opm-current-user',
  templateUrl: './current-user.component.html',
  styleUrls: ['./current-user.component.less'],
  standalone: false
})

export class CurrentUserComponent implements OnInit {

  constructor(
    private userService: UserService,
    private renderer: Renderer2,
    private popupService: PopupService,
    private msalService: MsalService
  ) {

    renderer.listen('document', 'click', (event) => {
      if (event.srcElement.id === 'toggle-button') {
        return;
      }
      this.popupService.hideAllPopups();
    });
  }

  popupId: string;
  popupVisibility = this.popupService.popupVisibility;
  currentUser: IGlobalEmployeeInfoModel;

  ngOnInit(): void {
    this.userService.getCurrentUserAsync()
      .then(data => {
        this.currentUser = data;
      });
  }

  toggleUserMenu = () => {
    this.popupService.togglePopupVisibility(PopupEnum.user);
  }

  logout(): void {
    this.msalService.logout();
  }
}
